export interface SamlConfig {
  idpMetadataUrl?: string;
  logoutRedirectUrl?: string;
  enabled: boolean;
  forbidPasswordLogins: boolean;
}

export function isSAMLWhitelistedURL(url: string): boolean {
  const whitelistedHosts = [
    'corewellhealth.org',
    'duosecurity.com',
    'jumpcloud.com',
    'loginmt.com',
    'mainfreight.com',
    'microsoftonline.com',
    'oastify.com',
    'okta.com',
    'onelogin.com',
    'vermeer.com'
  ];

  if (process.env.NODE_ENV !== 'production') {
    whitelistedHosts.push('127.0.0.1', 'localhost');
  }

  try {
    const { hostname } = new URL(url);
    return whitelistedHosts.some(
      whitelistedHost => hostname === whitelistedHost || hostname.endsWith(`.${whitelistedHost}`)
    );
  } catch (e) {
    return false;
  }
}
